module.exports = __webpack_public_path__ + "778ffc6befb729c8df3c14bfa8d1c5e5.jpg";